import { isInteractiveElement } from '@dnd-kit/dom/utilities';

import { type SortField } from './browser/types';

const FILE_EXTENSION_REGEXP = /(?:\.([^.]+))?$/;

export const SORT_OPTIONS: Array<{ value: SortField; label: string }> = [
  { value: 'name', label: 'Name' },
  { value: 'created_at', label: 'Created' },
  { value: 'size', label: 'Size' },
];

export const MAX_FILE_SIZE_MB = 2;
export const MAX_FILE_SIZE = 1024 * 1024 * MAX_FILE_SIZE_MB;

export const MAX_IMAGE_DIMENSION = 4096;

export const OPTIMIZATION_THRESHOLD_SIZE_MB = 1;
export const OPTIMIZATION_THRESHOLD_SIZE = OPTIMIZATION_THRESHOLD_SIZE_MB * 1024 * 1024;

export function getFileExtension(filename: string): string {
  const fileExtensionResult = FILE_EXTENSION_REGEXP.exec(filename);
  return fileExtensionResult == null ? '' : fileExtensionResult[1] ?? '';
}

export function fileSize(bytes: number): string {
  if (typeof bytes !== 'number' || Number.isNaN(bytes)) {
    return '0B';
  }
  if (bytes < 1000) return `${bytes}B`;
  if (bytes < 1_000_000) return `${(bytes / 1000).toFixed(1)}KB`;
  if (bytes < 1_000_000_000) return `${(bytes / 1_000_000).toFixed(1)}MB`;
  if (bytes < 1_000_000_000_000) return `${(bytes / 1_000_000_000).toFixed(1)}GB`;
  return `${(bytes / 1_000_000_000_000).toFixed(1)}TB`;
}

export async function getImageDimensions(imageUrl: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener('load', function () {
      resolve({ width: this.naturalWidth, height: this.naturalHeight });
    });
    img.addEventListener('error', reject);
    img.src = imageUrl;
  });
}

export function preventActivationOnInteractiveChildren(
  event: PointerEvent,
  source: { element?: Element | null; handle?: Element | null },
): boolean {
  const { target } = event;
  if (!(target instanceof Element)) return false;
  if (target === source.element) return false;
  if (target === source.handle) return false;
  if (isInteractiveElement(target) !== true) return false;
  if (source.handle?.contains(target) === true) return false;
  if (source.element?.contains(target) === true) return false;
  return true;
}
